import { createSlice } from "@reduxjs/toolkit";

import { FloorState } from "../states/FloorState";
import { getFloors, getFloor, getSvg, postFloor, deleteFloor, saveFloorMap } from "../actions/floorActions";

const initialState: FloorState = {
  floors: [],
  isLoading: false,
  success: false,
  floorLoadingState: "NotLoaded",
  floor: undefined,
};

const FloorSlice = createSlice({
  name: "Floor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFloors.pending, (state) => {
        state.isLoading = true;
        state.success = false;
      })
      .addCase(getFloors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.floors = action.payload;
      })
      .addCase(getFloors.rejected, (state) => {
        state.isLoading = false;
        state.success = false;
      })
      .addCase(getFloor.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.floorLoadingState = "Loading";
      })
      .addCase(getFloor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.floorLoadingState = "Loaded";
        state.floor = action.payload;
      })
      .addCase(getFloor.rejected, (state) => {
        state.isLoading = false;
        state.success = false;
        state.floorLoadingState = "Failed";
      })
      .addCase(getSvg.pending, (state) => {
        state.isLoading = true;
        state.success = false;
      })
      .addCase(getSvg.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(getSvg.rejected, (state) => {
        state.isLoading = false;
        state.success = false;
      })
      .addCase(postFloor.pending, (state) => {
        state.isLoading = true;
        state.success = false;
      })
      .addCase(postFloor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(postFloor.rejected, (state) => {
        state.isLoading = false;
        state.success = false;
      })
      .addCase(deleteFloor.pending, (state) => {
        state.isLoading = true;
        state.success = false;
      })
      .addCase(deleteFloor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(deleteFloor.rejected, (state) => {
        state.isLoading = false;
        state.success = false;
      })
      .addCase(saveFloorMap.pending, (state) => {
        state.isLoading = true;
        state.success = false;
      })
      .addCase(saveFloorMap.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(saveFloorMap.rejected, (state) => {
        state.isLoading = false;
        state.success = false;
      });
  },
});

export default FloorSlice.reducer;
